<template>
  <b-modal
    ref="bModal"
    hide-backdrop
    :no-close-on-backdrop="false"
    return-focus="searcherModule"
    no-fade
    :hide-footer="incidentClosed"
    modal-class="modalIncidentForm"
    style="z-index:0"
    @hide="onHide"
  >
    <template slot="modal-title">
      <div class="d-flex flex-column">
        <span qa="modal-incident-form-label">
          {{ label }}
        </span>
        <span
          v-if="!incidentId"
          class="mt-2"
        >{{ $t('laboratory.tracking.newIncident') }}</span>
      </div>
    </template>
    <div>
      <b-row class="p-3">
        <b-col>
          <span
            qa="modal-incident-form-incident-label"
            class="ap-title__section font-weight--medium primary-dark-color"
          >{{ incidentLabel }}</span>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col
          md
          sm="12"
          class="mb-sm-2"
        >
          <label>{{ $t('component.incidentModal.date') }}</label>
          <vt-date-picker
            :class="{ requiredcalendar: (showErrors && !formContent.incidentDate) }"
            :disabled="!!(incidentId)"
            :model.sync="formContent.incidentDate"
            qa="modal-incident-form-incident-date"
          />
        </b-col>
        <b-col
          md
          sm="12"
        >
          <label>{{ $t('component.incidentModal.area') }}</label>
          <vt-combo-select
            v-model="formContent.incidentOrigin"
            v-validate="'required'"
            :class="{ requiredform: (showErrors && !formContent.incidentOrigin) }"
            track-by="id"
            :options="incidentOrigins"
            label="name"
            data-vv-name="incidentOrigin"
            value-key="id"
            :disabled="!!(incidentId)"
            qa="modal-incident-form-incident-origin-select"
            @input="getIncidentTypes($event)"
            @select="onIncidentOriginSelect"
          />
        </b-col>
      </b-row>
      <b-row class="px-3 mt-3">
        <b-col
          md
          sm="12"
          class="mb-sm-2"
        >
          <label>{{ $t('component.incidentModal.type') }}</label>
          <vt-combo-select
            v-model="formContent.incidentType"
            v-validate="'required'"
            :options="incidentTypes"
            :class="{ requiredform: (showErrors && !formContent.incidentType) }"
            track-by="id"
            name="incidentType"
            label="name"
            data-vv-name="incidentType"
            value-key="id"
            :disabled="!formContent.incidentOrigin || !!(incidentId)"
            qa="modal-incident-form-incident-type-select"
            @input="onIncidentTypeSelect"
          />
        </b-col>
        <b-col
          md
          sm="12"
          class="mb-sm-2"
        >
          <label>{{ $t('component.incidentModal.severity') }}</label>
          <vt-combo-select
            v-model="formContent.incidentSeverity"
            v-validate="'required'"
            :class="{ requiredform: (showErrors && !formContent.incidentSeverity) }"
            track-by="id"
            :options="incidentSeverities"
            label="name"
            data-vv-name="incidentSeverity"
            :disabled="!!(incidentId) || disableIncidentSeverity"
            value-key="id"
            qa="modal-incident-form-severity-select"
          />
        </b-col>
      </b-row>
      <b-row class="px-3 mt-3">
        <b-col>
          <b-tabs
            align="center"
            class="tracking-tabs"
            pills
          >
            <b-tab
              title-item-class="flex-fill"
              :active="!incidentId"
            >
              <template slot="title">
                <span qa="modal-incident-form-opening-observations-tab">{{ $tc('component.incidentModal.open') }}</span>
              </template>
              <b-form-textarea
                v-model="formContent.openingObservations"
                v-validate="'required'"
                class="mt-2"
                :placeholder="$t('laboratory.tracking.noObservations')"
                row="4"
                no-resize
                :class="{ requiredform: (showErrors && !formContent.openingObservations) }"
                :disabled="!!(incidentId)"
                data-vv-name="openingObservations"
                qa="modal-incident-form-opening-observations-text-area"
              />
              <b-row
                v-if="incidentOpened"
                class="mt-3"
              >
                <b-col class="d-flex flex-column">
                  <label>{{ $t('component.incidentModal.openuser') }}</label>
                  <span
                    class="primary-dark-color"
                    qa="modal-incident-form-opening-observations-user"
                  >{{ openedBy.fullName }}</span>
                </b-col>
                <b-col class="d-flex flex-column">
                  <label>{{ $t('component.incidentModal.opendate') }}</label>
                  <span
                    class="primary-dark-color"
                    qa="modal-incident-form-opening-observations-date"
                  >{{ openingDate | datetime }}</span>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title-item-class="flex-fill"
              :active="!!(incidentId)"
              :disabled="!incidentId"
            >
              <template slot="title">
                <span qa="modal-incident-form-closing-observations-tab">{{ $tc('component.incidentModal.close') }}</span>
              </template>
              <b-form-textarea
                v-model="closingObservations"
                class="mt-2"
                :placeholder="$t('laboratory.tracking.noObservations')"
                :class="{ requiredform: (showFormCloseErrors && !closingObservations) }"
                :disabled="!incidentId || !!(closingDate)"
                row="4"
                no-resize
                qa="modal-incident-form-closing-observations-text-area"
              />
              <b-row
                v-if="incidentClosed"
                class="mt-3"
              >
                <b-col class="d-flex flex-column">
                  <label>{{ $t('component.incidentModal.closeuser') }}</label>
                  <span
                    class="primary-dark-color"
                    qa="modal-incident-form-closing-observations-user"
                  >{{ closedBy.fullName }}</span>
                </b-col>
                <b-col class="d-flex flex-column">
                  <label>{{ $t('component.incidentModal.closedate') }}</label>
                  <span
                    class="primary-dark-color"
                    qa="modal-incident-form-closing-observations-date"
                  >{{ closingDate | datetime }}</span>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <b-row class="px-3 mt-3">
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row class="px-3 mt-2">
        <b-col>
          <span class="ap-title ap-title__main">
            <i
              class="fal fa-envelope mr-2"
              aria-hidden="true"
            />
            {{ $t('component.incidentModal.notifications') }}
          </span>
        </b-col>
      </b-row>
      <b-row class="px-3 mt-2 multiselection">
        <b-col>
          <b-tabs
            align="center"
            class="tracking-tabs"
            pills
          >
            <b-tab
              title-item-class="flex-fill"
            >
              <template slot="title">
                <span qa="modal-incident-form-responsibilities-tab">{{ $tc('component.incidentModal.serviceResponsibilities') }}</span>
              </template>
              <vt-combo-select
                v-model="selectedResponsibilities"
                :disabled="!!(incidentId)"
                :class="{ requiredform: (showErrors && (mandatoryNotification && (!selectedPersonnelList.length && !selectedResponsibilities.length))) }"
                class="mt-2"
                track-by="label"
                :options="responsibilities"
                label="label"
                :multiple="true"
                qa="modal-incident-form-responsibilities-select"
              />
            </b-tab>
            <b-tab
              title-item-class="flex-fill"
              :title="$t('component.incidentModal.servicePersonal')"
            >
              <template slot="title">
                <span qa="modal-incident-form-personnel-tab">{{ $tc('component.incidentModal.servicePersonal') }}</span>
              </template>
              <vt-combo-select
                v-model="selectedPersonnelList"
                :disabled="!!(incidentId)"
                :class="{ requiredform: ((showErrors && mandatoryNotification) && (!selectedPersonnelList.length && !selectedResponsibilities.length)) }"
                class="mt-2"
                track-by="id"
                :options="personnel"
                label="fullName"
                :multiple="true"
                qa="modal-incident-form-personnel-select"
              />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
    >
      <div class="row">
        <div class="col-12 text-right">
          <vt-loading-button
            v-if="incidentId && !closingDate"
            class="btn--primary"
            :params="{ promise: closeIncident }"
            qa="modal-incident-form-close-button"
          >
            <i
              class="fal fa-times-circle mr-2"
              aria-hidden="true"
            />
            {{ $t('component.incidentModal.closeIncidence') }}
          </vt-loading-button>
          <vt-loading-button
            v-if="!incidentId"
            class="btn--primary"
            :params="{ promise: createIncident }"
            qa="modal-incident-form-register-button"
          >
            <i
              class="fal fa-share-square mr-2"
              aria-hidden="true"
            />
            {{ $t('component.incidentModal.register') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import incidentService, {
    COREENTITY_VALUES
} from '@/api/resources/incident/incidentServices'
import IncidentOriginServices from '@/api/resources/incident/incidentOriginServices'
import IncidentTypeService from '@/api/resources/incident/incidentTypeService'
import IncidentSeverityServices from '@/api/resources/incident/incidentSeverityServices'
import responsibilityService from '@/api/resources/responsibilityService'
import { personnelService } from '@/api/resources/personnelService'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { unionBy } from 'lodash'
import { StoreUtils } from '@/shared/util/store-utils'
import { commonLaboratoryService } from '@/api/resources/common/laboratory/common-laboratory.service'

export default {
    name: 'ModalIncidentForm',
    props: {
        idValue: String
    },
    data() {
        return {
            incidentId: null,
            incidentLabel: null,
            coreEntity: null,
            incidentSeverities: [],
            incidentOrigins: [],
            incidentTypes: [],
            personnel: [],
            responsibilities: [],
            formContentIncidentClosed: null,
            selectedResponsibilities: [],
            selectedPersonnelList: [],
            openedBy: null,
            openingDate: null,
            closingObservations: null,
            closedBy: null,
            closingDate: null,
            showFormCloseErrors: false,
            showErrors: false,
            disableIncidentSeverity: false,
            mandatoryNotification: false,
            entityIds: [],
            formContent: {
                incidentType: null,
                coreEntity: this.coreEntity,
                incidentOrigin: null,
                openingObservations: '',
                incidentDate: new Date(),
                incidentSeverity: null,
                notifyRequestingUnit: false,
                notifyRequestingPetitioner: false
            },
            selected: null,
            label: '',
            type: null,
            portionTypes: PORTION_TYPES
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        incidentOpened() {
            return this.incidentId && this.openedBy
        },
        incidentClosed() {
            return this.incidentId && this.closedBy
        },
        isCaseLaboratoryResponsibilities() {
            return this.coreEntity === COREENTITY_VALUES.CASE.code ||
                this.coreEntity === COREENTITY_VALUES.SAMPLE.code ||
                this.coreEntity === COREENTITY_VALUES.PORTION.code ||
                this.coreEntity === COREENTITY_VALUES.SUBPORTION.code
        }
    },
    watch: {
        formContent: {
            handler() {
                this.mandatoryNotification = !!(this.formContent.incidentSeverity && this.formContent.incidentSeverity.mandatoryNotification)
            },
            deep: true
        }
    },
    methods: {
        onIncidentTypeSelect(incidentType) {
            this.disableIncidentSeverity = !!(incidentType.incidentSeverity)
            this.formContent.incidentSeverity = incidentType.incidentSeverity
        },
        onIncidentOriginSelect(incidentOrigin) {
            this.selectedPersonnelList = unionBy(this.selectedPersonnelList, incidentOrigin.defaultPersonnelList, 'id')
            this.formContent.incidentType = null
            this.formContent.incidentSeverity = null
            this.disableIncidentSeverity = false
        },
        onHide() {
            this.$eventHub.$emit('focus-searcherModule')
            this.$_cleanComponentData()
        },
        async show(coreEntity, entityIds, incidentId, elementSelected, incidentLabel) {
            this.label = elementSelected.porLabel || elementSelected.supLabel
            this.type = elementSelected.portionTypeEnum
            this.updateLoading(true)
            this.entityIds = entityIds
            this.coreEntity = coreEntity
            this.incidentLabel = incidentLabel
            this.formContent.coreEntity = this.coreEntity
            if (incidentId) {
                let err, response
                switch (this.coreEntity) {
                case COREENTITY_VALUES.PORTION.code:
                    [err, response] = await this.toCall(
                        incidentService.getPortionIncident(
                            this.labId,
                            ...this.entityIds,
                            incidentId
                        )
                    )
                    break
                case COREENTITY_VALUES.SUBPORTION.code:
                    [err, response] = await this.toCall(
                        incidentService.getSubportionIncident(
                            this.labId,
                            ...this.entityIds,
                            incidentId
                        )
                    )
                    break
                }
                if (err || !response) {
                    this.showErrorModalGlobal()
                    this.hide()
                    return
                }
                this.incidentId = incidentId
                this.incidentTypes = [response.incidentType]
                this.formContent = {
                    incidentType: response.incidentType,
                    coreEntity: response.coreEntity.code,
                    incidentOrigin: response.incidentOrigin,
                    openingObservations: response.openingObservations,
                    incidentDate: response.incidentDate,
                    incidentSeverity: response.incidentSeverity,
                    notifyRequestingPetitioner: !!response.notifiedPetitioner,
                    notifyRequestingUnit: !!response.notifiedDepartment
                }
                this.selectedPersonnelList = response.notifiedPersonnelList
                this.selectedResponsibilities = response.notifiedResponsibilityList.map(responsibilityLaboratory => {
                    const responsibility = responsibilityLaboratory.responsibility
                    const laboratory = responsibilityLaboratory.laboratory
                    return {
                        laboratoryId: laboratory.labId,
                        label: `${responsibility.translatedName} (${laboratory.labName})`,
                        code: responsibility.code
                    }
                })
                this.openedBy = response.openedBy
                this.openingDate = response.openingDate
                this.closingObservations = response.closingObservations
                this.closedBy = response.closedBy
                this.closingDate = response.closingDate
            }
            const [errorIncidentOrigins] = await this.toCall(Promise.all([
                this.getIncidentOrigins(),
                this.getIncidentSeverities(),
                this.loadResponsibilities(),
                this.getPersonnel()]))
            this.updateLoading(false)
            if (errorIncidentOrigins) {
                this.showErrorModalGlobal()
                return
            }
            this.$refs.bModal.show()
        },
        async validate() {
            return this.$validator.validate()
        },
        async createIncident() {
            const formValidator = await this.validate()
            let mandatoryNotificationValidation = true
            if (this.mandatoryNotification) {
                mandatoryNotificationValidation = this.selectedPersonnelList.length || this.selectedResponsibilities.length
            }
            if (!formValidator || !this.formContent.incidentDate || !mandatoryNotificationValidation) {
                this.showErrors = true
                this.showErrorModalGlobal(this.$t('studyRequest.create.incompleteFormModal.content'))
            } else {
                this.showErrors = false
                this.formContent.notifiedPersonnelIds = this.selectedPersonnelList.map((personnel) => personnel.id)
                this.formContent.notifiedResponsibilityAndLaboratoryIds = this.selectedResponsibilities
                    .map((responsibility) => {
                        return {
                            laboratoryId: responsibility.laboratoryId,
                            responsibility: responsibility.code
                        }
                    })
                this.formContent.incidentOriginId = this.formContent.incidentOrigin.id
                this.formContent.incidentSeverityId = this.formContent.incidentSeverity.id
                this.formContent.incidentTypeId = this.formContent.incidentType.id
                let err, save
                switch (this.coreEntity) {
                case COREENTITY_VALUES.PORTION.code:
                    [err, save] = await this.toCall(
                        incidentService.openPortionIncident(
                            this.labId,
                            ...this.entityIds,
                            this.formContent
                        )
                    )
                    break
                case COREENTITY_VALUES.SUBPORTION.code:
                    [err, save] = await this.toCall(
                        incidentService.openSubportionIncident(
                            this.labId,
                            ...this.entityIds,
                            this.formContent
                        )
                    )
                    break
                }
                if (err || !save) {
                    this.showErrorModalGlobal()
                    return
                }
                this.incidentId = save.data ? save.data.incidentId : save.incidentId
                this.incidentLabel = save.data ? save.data.incLabel : save.incLabel
                this.showSuccessModalGlobal(this.$t('component.incidentModal.saved'))
                this.$emit('incidentAdded')
            }
        },
        async closeIncident() {
            if (!this.closingObservations) {
                this.showFormCloseErrors = true
                return
            }
            this.showFormCloseErrors = false
            const closeContent = { closingObservations: this.closingObservations }
            let err, response
            switch (this.coreEntity) {
            case COREENTITY_VALUES.PORTION.code:
                [err, response] = await this.toCall(
                    incidentService.closePortionIncident(
                        this.labId,
                        ...this.entityIds,
                        this.incidentId,
                        closeContent
                    )
                )
                break
            case COREENTITY_VALUES.SUBPORTION.code:
                [err, response] = await this.toCall(
                    incidentService.closeSubportionIncident(
                        this.labId,
                        ...this.entityIds,
                        this.incidentId,
                        closeContent
                    )
                )
                break
            }
            if (err || !response) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            this.showSuccessModalGlobal(this.$t('component.incidentModal.closed'))
            this.closingDate = response.closingDate
            this.$emit('incidentClosed')
            this.hide()
        },
        async getIncidentOrigins() {
            this.incidentOrigins = Object.values(
                await IncidentOriginServices.findAllActiveOrigins(this.labId, this.coreEntity)
            ).sort((a, b) => a.name.toLocaleUpperCase().localeCompare(b.name.toLocaleUpperCase()))
        },
        async getIncidentTypes(incidentOrigin) {
            this.incidentTypes = Object.values(
                await IncidentTypeService.findAllActiveIncidentTypes(
                    this.labId,
                    incidentOrigin.id,
                    this.coreEntity
                )
            ).sort((a, b) => a.name.toLocaleUpperCase().localeCompare(b.name.toLocaleUpperCase()))
        },
        async getIncidentSeverities() {
            this.incidentSeverities = Object.values(await IncidentSeverityServices.getSeverities(this.labId))
        },
        async getCaseLaboratories() {
            const response = await this.$_toCallUnique(commonLaboratoryService.getCaseLaboratories(this.entityIds[0]))
            return response ?? []
        },
        mapResponsibilities(responsibilities, laboratories) {
            let responsibilitiesMap = []
            laboratories.forEach(laboratory => {
                responsibilities.forEach(responsibility => {
                    responsibilitiesMap.push({
                        laboratoryId: laboratory.labId,
                        code: responsibility.code,
                        label: `${responsibility.translatedName} (${laboratory.labName})`
                    })
                })
            })
            return responsibilitiesMap
        },
        async loadResponsibilities() {
            let laboratories = []
            if (StoreUtils.selectedLaboratoryConfiguration) {
                laboratories = [StoreUtils.selectedLaboratoryConfiguration]
            }
            if (this.isCaseLaboratoryResponsibilities) {
                laboratories = await this.getCaseLaboratories()
            }
            const response =
                await this.$_toCallUnique(
                    responsibilityService.findAllResponsibilitiesByLaboratory(this.labId))
            this.responsibilities = response ? this.mapResponsibilities(response, laboratories)
                .sort((a, b) => a.label.localeCompare(b.label)) : []
        },
        async getPersonnel() {
            this.personnel = await personnelService.getPersonnel(this.labId)
        },
        hide() {
            this.hasList = !this.hastList
            this.$refs.bModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .requiredform .multiselect__tags {
        border-color: red !important;
    }

    .requiredform {
        border-color: red !important;
    }

    .requiredcalendar .mx-input {
        border-color: red !important;
    }

.modalIncidentForm .multiselection .multiselect__tags {
  height: calc(1.5em + 0.5rem + 70px) !important;
  line-height: 1.5;
  overflow-y: auto;
}

.modalIncidentForm .card {
  border: 1px solid vt-color(red-medium, 0.4);
}

.modalIncidentForm .incident-list-content {
  height: calc(100vh - 170px);
  overflow-y: auto;
  overflow-x: hidden;
}
.modalIncidentForm .card-info {
  font-size: font-size(small);
}

.modalIncidentForm .mx-input {
  height: calc(1.5em + 0.5rem + 9px) !important;
}

.modalIncidentForm textarea.form-control {
  height: 70px !important;
}

.modalIncidentForm .tracking-tabs .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: transparent;
  color: vt-color(primary);
  border-radius: 0;
}

.modalIncidentForm .nav-link.disabled {
  opacity: 0.5;
}

.modalIncidentForm .tracking-tabs .nav-link.active {
  position: relative;
}

.modalIncidentForm .tracking-tabs .nav-link.active i {
  color: vt-color(primary);
}

.modalIncidentForm .tracking-tabs .nav-link.active:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2px 2px 0 0;
  width: 90%;
  height: 5px;
  background: vt-color(primary);
  bottom: 0;
}

.modalIncidentForm .nav-item {
  border-bottom: 0.5px solid rgb(184, 184, 184) !important;
}

.modalIncidentForm .nav-item i {
  color: vt-color(base-text);
  font-size: font-size(big);
}

.modalIncidentForm .nav-link {
  padding: 0.7rem 1rem;
  border-color: transparent !important;
}

.modalIncidentForm .multiselect__tags {
  height: calc(1.5em + 0.5rem + 9px);
  padding: 0.35rem 0.5rem;
}

.modalIncidentForm label {
  margin-bottom: 0;
  font-size: font-size(small);
}

.modalIncidentForm .modal-dialog {
  width: 45% !important;
  margin: 0;
  position: absolute;
  right: 0;
}

.modalIncidentForm .modal-body {
  padding: 0.6rem 1.1rem 0 1.1rem !important;
    overflow-y: auto;
}

.modalIncidentForm .modal-content {
  top: 50px;
  // TODO: Refactoring required for modal height
  height: calc(100vh - 78px);
  border-radius: 0;
  box-shadow: -3px 0px 10px 2px #8f8f8f !important;
}

.modalIncidentForm .modal-footer {
  border-top: 0;
}
</style>

<style scoped>
.modalIncidentForm {
  color: #303133;
}

.modalIncidentForm h4 {
  font-weight: normal;
}
</style>
